import {
  queryOptions,
  usePrefetchQuery,
  useSuspenseQuery,
} from "@tanstack/react-query"

import { getDefaultLocales } from "../../app/services/locales"

export function useDefaultLocalesQuery() {
  return useSuspenseQuery(defaultLocalesQueryOptions)
}

const defaultLocalesQueryOptions = queryOptions({
  queryKey: ["defaultLocales"],
  queryFn: getDefaultLocales,
})

export function usePrefetchDefaultLocalesQuery(): void {
  usePrefetchQuery(defaultLocalesQueryOptions)
}
